import {clearStopVideo, isVideoSrc} from "../lib/service/html.service";

require('./quill-editor/quill.core.css');
require('./quill-editor/quill.bubble.css');
require('./style/poi-editor.scss');

import Pannellum from './pannellum-admin';
import Viewer from '../tour';
import BottomControls from './pannellum-controls-admin';
import E3PlanPanel from '../lib/e3plan-panel/e3plan-panel';
import DetectRoomPanel from '../lib/floorplan-detect';
import { isMetrical } from 'service/geo.service';
import FloorplanManager from '../lib/service/e3.plan.manager';
import getCookie from 'lib/cookie/getCookie';
import setCookie from 'lib/cookie/setCookie';
import { FLOORPLAN_CONFIG_MAPPING } from 'a_root-folder/constants';
import {validURL, updateInfoIconStyle} from 'lib/helpers/common';
import E3GoogleMap from 'lib/e3-google-map/e3-google-map';
import {patchOldPOI} from './poi-service';
import BlurControlller from 'lib/blur';
import RenderZoneController from 'lib/video-zone';
import {FONT_SIZE} from "a_root-container/react-planner/src/constants";
import initInfoSwiper from '../lib/swiper';

const debounce = require('lodash/debounce');
const Quill = require('./quill-editor/quill.js');
const shortid = require('shortid');
const pick = require('lodash/pick');
const merge = require('lodash/merge');
const loadImage = require('blueimp-load-image');

class AdminViewer extends Viewer {
    _Pannellum = Pannellum;
    _BottomControls = BottomControls;
    blurEditMode = false;
    renderZoneEditMode = false;
    _floorplanPanel = null;
    _prevFloorplan = null;
    _drawing = false;
    _disableE3Plan3DInterrupting = false;
    _saving = false;
    _firstUpload = false;

    get _defaultFloorplanDetails(){
        if(!getCookie(this.frontendCompanyID)) return this.viewer.getFloorplanDetails();

        const frontend_config = JSON.parse(getCookie(this.frontendCompanyID));
        const configs  = frontend_config['default'];
        const defaultConfig = {};

        let opts = Object.keys(configs);
        opts.forEach(opt => {
            defaultConfig[FLOORPLAN_CONFIG_MAPPING[opt]] = configs[opt];
        })

        return defaultConfig;
    }

    /**
     * Saves floorplan object with debounce.
     * @private
     */
    _debounceSavePlan() {
        if (!this._debounceSavePlanFunc) {
            this._debounceSavePlanFunc = debounce(()=> {
                this.saveFloorplanServer();
                this._saving = false;
            }, 5000)
        }
        this._saving = true;
        this._debounceSavePlanFunc();
    }

    isSaving(){
        return this._saving;
    }

    isFloorplan(){
        return this._floorplanPanel;
    }

    updateE3Floorplan(){
        let floorplan = this.viewer.getPlan();
        floorplan.preview = this.viewer.getPlanPreview();

        if (this._e3plan3D && !this._disableE3Plan3DInterrupting) {
            if (this._e3plan3D.isHidden())
                this._e3plan3D.resetConfig(floorplan.preview);
            else
                this._e3plan3D.resetConfig(floorplan.preview, false);
        }

        return floorplan;
    }

    saveFloorplanLocal(){
        this._fireEvent('floorplan.e3.save', this.updateE3Floorplan());
    }

    saveFloorplanServer(){
        if(!this._floorplanPanel) return ;

        this._floorplanPanel.showAutoSaving();

        this._fireEvent('floorplan.save', this.updateE3Floorplan());

        this._drawing = false;
    }

    onSaveFloorplan(){
        return new Promise((req, res) => {
            let interval = null;
            function checkStatusOfDrawing(){
                if(!this._drawing){
                    req();
                    clearInterval(interval);
                }
            }

            interval = setInterval(() => checkStatusOfDrawing.apply(this), 500);
        })
    }

    _deleteFloorFromPanel(id, result, e) {
        e && e.preventDefault();
        if (result) {
            const isNeedCrearPoints = this.viewer.isCurrentArea(id);
            this.viewer.deleteLayer(id);
            if(isNeedCrearPoints){
                this.viewer.clearPoints(false);
                this._floorplanPanel.hideControl('add');
                this._floorplanPanel.switchControl('add', true);
            }
            this._floorplanPanel.updateFloors(this.viewer.getFloornames(), this.viewer.getCurrentFloor());
            this._onPreview();
            this._debounceSavePlan();
        }

        this._modalService.close('confirm');
    }

    _changeFloors(obj) {
        this.viewer.changeFloors(obj);
        this._onPreview();
        this._debounceSavePlan();
    }

    _deleteHole(id, result, e) {
        e && e.preventDefault();
        if (result) {
            this.viewer.deleteHole(id);
            // this._floorplanPanel.updateFloors(this.viewer.getFloornames(), this.viewer.getCurrentFloor());
            this._onPreview();
            this._debounceSavePlan();
        }

        this._modalService.close('confirm');
    }

    _destroyInfoModalAlert() {
        if (!this._infoModal.alert) return;
        this._infoModal.alert.confirm.removeEventListener('click', this._infoModal.alert.confirmHandler);
        this._infoModal.alert.cancel.addEventListener('click', this._infoModal.alert.cancelHandler);
        this._infoModal.alert = null;
    }

    _hideInfoModal() {
        this._infoModal.container.classList.remove('show-info-editor');
        this._infoModal.container.classList.remove('hide-e3-poi');
        this._infoModal.targetNode.classList.remove('e3-poi-editing');

        this._fireEvent('poi.editor.close');
    }

    _hideInfoModalAlert(e) {
        if (e && e.stopPropagation) e.stopPropagation();
        if (!this._infoModal.alert) return;
        this._infoModal.alert.container.classList.remove('show');
        this._infoModal.alert.confirm.removeEventListener('click', this._infoModal.alert.confirmHandler);
    }

    _disableVideoInfoModal() {
        let videos = this._infoModal.container.querySelectorAll('.ql-editor iframe');
        Array.from(videos).forEach((iframe) => {
            let {src} = iframe;
            if(src.match(/(mov|avi|wmv|flv|3gp|mp4|mpg)$/)) iframe.src = src + '_';
        })
    }

    _enableVideoInfoModal(poiBodyNode) {
        return new Promise((res, rej) => {
            let isVideoInside = false;
            let videos = poiBodyNode.querySelectorAll('.ql-editor iframe');
            Array.from(videos).forEach((iframe) => {
                let {src} = iframe;
                if(isVideoSrc(src)) {
                    isVideoInside = true;
                    iframe.src = clearStopVideo(src);
                }
            })
            if(!isVideoInside) return res();

            setTimeout(() => res(), 1000);
        })
    }
    
    _patchOldInfo() {
        return new Promise((res, rej) => {
            try {
                const {hotspots} = this._getCurrentScene();
                const poiHotspots = hotspots.filter(({poiID}) => poiID);

                if(poiHotspots.filter(({order}) => order).length === poiHotspots.length) return res();

                poiHotspots.forEach(async ({order, poiID}, ind) => {
                    if (!order) {
                        await this._orderHotspotUpdate(poiID, ind + 1);
                    }
                })
                this._fireEvent('poi.reinit');
                this._fireEvent('poi.editor.close');

                res();
            } catch (e) {
                console.error(e);
            }
        })
    }

    _initAudioButton() {
        const poiEditor = this.poiEditor;

        this._audioInfoListener = {
            autoPlay: (play) => {
                return poiEditor.container.querySelectorAll('audio').forEach((audio) => {
                    audio.currentTime = 0 ;
                    audio[play ? 'play' : 'pause']();
                });
            }
        }

        const onInfoAudioButton = (e) => {
            e.preventDefault();
            e.stopPropagation();

            const onUpload = () => {
                this._waitForSaving = true;

                const fileInput = document.createElement('input');
                fileInput.type = 'file';
                fileInput.id = 'audioFileInput';
                document.body.appendChild(fileInput);
                fileInput.click();
        
                const listener = (event) => {
                    this._fireEvent('poi.audio', event.target.files);
                    fileInput.removeEventListener('change', listener);
                    document.body.removeChild(fileInput);

                    this._waitForSaving = false;
                }
        
                fileInput.addEventListener('change', listener);
                const cancel = () => this._waitForSaving = false;
                fileInput.addEventListener('cancel', cancel);

                this._infoModal.events.push(...[
                    {
                        event: fileInput,
                        callback: listener,
                        action: 'change'
                    },
                    {
                        event: fileInput,
                        callback: cancel,
                        action: 'cancel'
                    }
                ]);
            }

            const isEmptyContent = this._infoModal.html == '<p><br></p>' || this._infoModal.html === '';
            if(isEmptyContent) return onUpload();

            this._modalService.confirm(this._translateService.translate('PROCEED_AUDIO_UPLOAD'), 
                (agree) => {
                    this._modalService.close('confirm');
                    this._waitForSaving = false;

                    if(!agree) return false;

                    return onUpload();
                    
                }, 'audio-upload');
        }

        var audioButton = document.querySelector('.ql-audio');
        const callback =  onInfoAudioButton.bind(this);
        audioButton.addEventListener('click', callback);
        this._infoModal.events.push({
            event: audioButton,
            callback: callback,
            action: 'click'
        });
        this.on('poi.audio.on.upload', ({urls}) => {
            urls.forEach((url) => {
                const poiEditor = this.poiEditor;
                poiEditor.setContents([]);
                poiEditor.insertEmbed(0, 'audio', url);
                poiEditor.clipboard.dangerouslyPasteHTML(index+1, `<p></p>`);
                this._poiAsyncAction = null;
            })
        })
    }

    _onDragEvent() {
        const dropZone = this._infoModal.container;

        dropZone.addEventListener('dragover', (event) => {
            event.preventDefault();
        });

        dropZone.addEventListener('dragleave', () => {

        });

        dropZone.addEventListener('drop', (event) => {
            event.preventDefault();
            dropZone.style.borderColor = '#ccc';

            const files = Array.from(event.dataTransfer.files);
            const imageFiles = files.filter(file => file.type.startsWith('image/'));

            if (imageFiles.length > 1) {
                const maxWidth = 2000;
                let ratio = 1;
                const imagePromises = [];

                // Convert each image file to a data URL using promises
                Array.from(imageFiles).forEach((file) => {
                  const imagePromise = new Promise((resolve, reject) => {
                    loadImage(
                      file,
                      function (img) {
                        if (img.width > maxWidth) {
                          ratio = maxWidth / img.width;
                        }
                        const width = img.width * ratio;
                        const height = img.height * ratio;

                        const canvas = document.createElement("canvas");
                        canvas.width = width;
                        canvas.height = height;

                        const ctx = canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0, width, height);

                        const dataURL = canvas.toDataURL("image/jpeg");
                        resolve(dataURL);  // Resolve the promise with the data URL
                      }.bind(this),
                      { orientation: true }
                    );
                  });
                  imagePromises.push(imagePromise);  // Add each promise to the array
                });

                // Wait for all image processing promises to resolve
                Promise.all(imagePromises).then((imageUrls) => {
                  const index = this.poiEditor.getSelection() ? this.poiEditor.getSelection().index : 0;
                  this.poiEditor.insertEmbed(index, 'carousel', { imageCarousel: { images: imageUrls } });
                  this.poiEditor.clipboard.dangerouslyPasteHTML(index+1, '<p></p>');
                  this._poiAsyncAction = Promise.resolve();
                  setTimeout(() => this._poiAsyncAction = null, 2000)
                }).catch((err) => {
                  console.error('Error processing images:', err);  // Handle any errors that occur
                });
            } else if (imageFiles.length === 1) {
               
            } else {
                alert('Please drop an image file.');
            }
        });
    }

    async _initEditor(container) {
        const editorTemplate = require('./poi-editor.html');
        const editorId = 'e3-poi-editor';

        let editor = document.createElement('div');
        editor.classList.add('e3-viewer-poi-editor-wrapper');
        editor.id = editorId;
        editor.innerHTML = editorTemplate;

        container.appendChild(editor);

        await this._patchOldInfo();

        this.poiEditor = new Quill('.e3-viewer-poi-editor-body', {
            theme: 'bubble',
            modules: {
                toolbar: {
                    container: '.e3-viewer-poi-toolbar',
                    handlers: {
                        'save': function () {
                            this._infoModal.saveHandler();
                        }.bind(this),
                        'delete': function () {
                            this._infoModal.deleteHandler();
                        }.bind(this)
                    }
                },
                history: {
                    delay: 1000,
                    maxStack: 100,
                    userOnly: true,
                    buttons: {
                        'undo': '.ql-undo',
                        'redo': '.ql-redo',
                    }
                }
            },
            tooltipContainer: editor.querySelector('.e3-viewer-poi-toolbar')
        });

        var customButton = document.querySelector('.ql-street');
        customButton.addEventListener('click', () => {
            this._onOpenGmapStreet({editor: this.poiEditor});
        });
        
        const close = document.querySelector('.ql-close');
        close.addEventListener('click', () => {
            const content = this._infoModal.targetNode;

            if (content.classList.contains('pnlm-info-fullscreen')) {
                this._savePoi()
                    .then(() => {
                        this._closeInfoModal();
                        content.classList.remove('pnlm-info-fullscreen');
                        this._toggleLogo(false);
                        close.classList.add('hidden');
                        this._infoModal.hidden = true;
                    })
                    .catch((err) => console.log(err));
            } else {
                content.classList.add('pnlm-info-fullscreen');
                this._toggleLogo(true);
                close.classList.remove('hidden');
                this._infoModal.hidden = false;
            }
        });

        this._initAudioButton();

        var fullscreenButton = document.querySelector('.ql-fullscreen');
        fullscreenButton.addEventListener('click', () => {
            this._infoFullscreenMode();

            if (this._isBtnDisabled('save')) this._toggleAccess('save', true);
        });

        var exitFullscreenButton = document.querySelector('.ql-exit-fullscreen');
        exitFullscreenButton.addEventListener('click', () => {
            this._infoFullscreenMode();

            if (this._isBtnDisabled('save')) this._toggleAccess('save', true);
        });

        this._infoModal.toolbarContainer = container.querySelector('.e3-viewer-poi-toolbar');
        this._infoModal.editorContainer = container.querySelector('.e3-viewer-poi-editor');
        this._infoModal.saveButton = container.querySelector('.ql-save');
        this._infoModal.deleteButton = container.querySelector('.ql-delete');
        this._infoModal.closeButton = container.querySelector('.e3-viewer-modal-close');
        this._infoModal.titleField = container.querySelector('.e3-viewer-poi-title-field');
        this._infoModal.orderField = container.querySelector('.select-order');
        this._infoModal.langField = container.querySelector('.select-lang');
        this._infoModal.loader = container.querySelector('.e3-viewer-poi-loader');
        this._infoModal.iconSelect = container.querySelector('.select-image');
        this._infoModal.getMenuButton = (button) => {
            return this._infoModal.toolbarContainer.querySelector(`.ql-${button}`) || null;
        }

        this._infoModal.saveHandler = () => {
            this._poiAsyncAction = this._savePoi()
        };
        this._infoModal.deleteHandler = this.onDeletePoi.bind(this);
        this._infoModal.editorChangeHandler = this._onEditorChanges.bind(this);
        this._infoModal.titleChangeHandler = this._onTitleChanges.bind(this);

        this._infoModal.titleField.addEventListener('input', this._infoModal.titleChangeHandler);
        this._infoModal.type = 'editor';

        // Hide iframe feature for not paid in priceplan
        this._checkPricePlanForInfo(container);

        this._infoModal = this._initInfoLang(this._infoModal);
        this._infoModal = this._initInfoSelect(container, this._infoModal);
        this._infoModal = this._initInfoOrder(container, this._infoModal);
        
        this._initIconUpload(container, this._infoModal);
    }

    _infoFullscreenMode(){
        const content = this._infoModal.targetNode;
        const logo = document.querySelector('.company-logo');

        if (content.classList.contains('pnlm-info-fullscreen')) {
            content.classList.remove('pnlm-info-fullscreen');
            this._toggleLogo(false);
            this._toogleCloseButton();
            this._infoModal.size = 'balloon';
        } else {
            content.classList.add('pnlm-info-fullscreen');
            logo.classList.add('hidden');
            this._toggleLogo(true);
            this._toogleCloseButton(false);
            this._infoModal.size = 'fullscreen';
        }
    }

    _toogleCloseButton(flag=true){
        const close = document.querySelector('.ql-close');
        if(flag){
            close.classList.add('hidden');
        }else{
            close.classList.remove('hidden');
        }
    }

    _toggleLogo(flag=true){
        const logo = document.querySelector('.company-logo');
        if(flag){
            logo.classList.add('hidden');
        }else{
            logo.classList.remove('hidden');
        }
    }

    _checkPricePlanForInfo(container){
        if(!Number(this.priceplan.customizable_label_icon)) container.querySelector('.select-image .icon-upload').style.display = 'none';
        if(!Number(this.priceplan.info_label_embed_iframe)) container.querySelector('.ql-iframe').style.display = 'none';
        if(!Number(this.priceplan.infolabel_fullscreen_enabled)) container.querySelector('.ql-fullscreen').style.display = 'none';
    }

    _initIconUpload(container, infoModal) {
        let initIconUpload = container.querySelector('.select-image .icon-upload');

        if (!initIconUpload) return null;
        let infoModalID = this._infoModal.id;

        initIconUpload.addEventListener('change', (files) => {
            return new Promise((resolve, reject) => {
                this._fireEvent('customizable_label_icon', this._preparePoiToSend(files), (res) => resolve(res));
            }).then((res) => {
                this._savePoiCallback(res, infoModalID);
                let {icon} = res.data;
                this._setActiveIcon(icon);

                this._infoModal.icon = icon;
                this._poiAsyncAction = null;
                return Promise.resolve();
            });

        }, false);

        return initIconUpload;
    }

    _initInfoSelect(container, infoModal) {
        let iconSelect = container.querySelector('.select-image');

        if (!iconSelect) return null;

        infoModal.iconSelect = iconSelect;
        infoModal.iconSelectHandler = this._iconSelectHandler.bind(null, iconSelect, 'select-image');
        infoModal.iconSetTypeHandler = this._iconSetTypeHandler.bind(this, iconSelect);

        let activeIcon = iconSelect.querySelector('.select-image-active');
        let iconListWrapper = iconSelect.querySelector('.select-image-container');
        activeIcon.addEventListener('click', infoModal.iconSelectHandler, false);
        iconListWrapper.addEventListener('click', infoModal.iconSetTypeHandler, false);

        return infoModal;
    }

    _getCurrentScene() {
        const currentScene = this.viewer.getScene().toString();

        return this.config.scenes.find((s) => s.id === currentScene);
    }

    async _orderSetTypeHandler(order, e) {
        const {hotspots} = this._getCurrentScene();
        const value = e.target.dataset['value'];
        const valueOld = order.querySelector('.select-order-active').dataset['value'];
        const hotspot = hotspots.find((hotspot) => hotspot.order === value);
        const content = order.querySelector('.select-order-active');
        const poiID = this._infoModal.id;

        if (hotspot) {
            await this._orderHotspotUpdate(hotspot.poiID, valueOld);
        }

        content.innerText = value;
        content.dataset.value = value;
        this._iconSelectHandler(order, 'select-order');
        this._infoModal.order = value;
        
        await this._orderHotspotUpdate(poiID, value);
        this._fireEvent('poi.reinit');
        this._fireEvent('poi.editor.close');
    }

    _orderHotspotUpdate(poiID, order) {
        return new Promise((resolve, reject) => {
            try {
                this._fireEvent('poi.save', {
                    poiID,
                    order
                },  (res) => resolve(res));
            } catch (e) {
                console.error(e);
                reject(e);
            }
        })
    }
    
    _initInfoLang(infoModal) {
        const lang = this._infoModal.langField;

        if (!lang) return null;

        const active = lang.querySelector('.select-lang-active');
        active.dataset.value = infoModal.lang;
        active.textContent = infoModal.lang;

        infoModal.langHandler = this._iconSelectHandler.bind(this, lang, 'select-lang');
        infoModal.langSetTypeHandler = this._langSetHandler.bind(this, lang);

        const wrapper = lang.querySelector('.select-lang-container');
        
        active.addEventListener('click', infoModal.langHandler, false);
        wrapper.addEventListener('click', infoModal.langSetTypeHandler, wrapper);

        return infoModal;
    }
    
    _langSetHandler(lang, e) {
        const value = e.target.dataset['value'];
        this._iconSelectHandler(lang, 'select-lang');
        this._setPoeContainer(this._infoModal.container, value);
        this._infoModal.saveHandler();
    }

    parseInfoContainer(html, lang=this._countryCode) {
        lang = this.prepareLang(lang);
        if(this.isJSON(html)) {
            const obj = JSON.parse(html);
            
            html = obj[lang.toUpperCase()] || '<p></p>';
        }

        return html;
    }

    _setPoeContainer(container=this._infoModal.container, lang=this._countryCode) {
        let html = this._infoModal.original

        html = this.parseInfoContainer(html, lang);

        this._setActiveLanguage(lang.toUpperCase());

        html = patchOldPOI(html);
        container.querySelector('.ql-editor').innerHTML = html;
        initInfoSwiper(this._infoModal.container.querySelectorAll('.swiper-container'));
    }

    _setActiveLanguage(value) {
        const content = this._infoModal.langField.querySelector('.select-lang-active');

        content.dataset.value = value;
    }

    _initInfoOrder(container, infoModal) {
        const order = container.querySelector('.select-order');

        if (!order) return null;

        const active = order.querySelector('.select-order-active');
        active.dataset.value = infoModal.order;
        active.textContent = infoModal.order;

        infoModal.orderHandler = this._iconSelectHandler.bind(null, order, 'select-order');
        infoModal.orderSetTypeHandler = this._orderSetTypeHandler.bind(this, order);

        const wrapper = order.querySelector('.select-order-container');
        const {hotspots} = this._getCurrentScene();
        hotspots
            .filter(({poiID}) => poiID)
            .map((hotspot, ind) => {
                if (!hotspot.order) {
                    hotspot.order = ind;
                }

                return hotspot;
            })
            .sort((a, b) => a.order - b.order)
            .forEach((hotspot) => wrapper.appendChild(this._generateOrderDiv(hotspot.order)));

        active.addEventListener('click', infoModal.orderHandler, false);
        wrapper.addEventListener('click', infoModal.orderSetTypeHandler, wrapper);

        return infoModal;
    }

    _generateOrderDiv(order) {
        const orderDiv = document.createElement('div');
        orderDiv.classList.add('select-order-item');
        orderDiv.dataset.value = order;
        orderDiv.innerHTML = order;

        return orderDiv;
    }

    _iconSelectHandler(iconSelect, selector) {
        let iconListWrapper = iconSelect.querySelector(`.${selector}-container`);
        iconListWrapper.classList.toggle('visible');

        this._infoModal.saveHandler();
    }

    _initMsgListener(id){
        this.receiveMessageFromInfoLabelListener = this.receiveMessageFromInfoLabel.bind(this, id);
        window.addEventListener("message", this.receiveMessageFromInfoLabelListener, false);
    }

    receiveMessageFromInfoLabel(idBlock, event){
        if(event.data && typeof event.data === 'string'){
            try {
                const {id, data} = JSON.parse(event.data);

                if(id === 'setStyle'){
                    const style = JSON.parse(data);
                    const img = this.findImage(style);

                    // if(img) this._setActiveIcon(img);
                    updateInfoIconStyle(style, idBlock, this.config);

                    this.viewer._renderHotSpots();
                }
            }catch{
            }
        }
    }

    findImage(style){
        if(style && style.icon){
            for(let y in style.icon){
                if(y == 'content'){
                    return style.icon[y].replace('url(', '').replace(')', '');
                }
            }
        }

        return false;
    }

    _destroyMsgListener(){
        window.removeEventListener("message", this.receiveMessageFromInfoLabelListener, false);
    }

    _iconSetTypeHandler(iconSelect, e) {
        let type = e.target.dataset['value'];
        let currentType = iconSelect.dataset['value'];

        this._changeInfoIcon(type, currentType);      
    }

    _changeInfoIcon(type, currentType) {
        const iconSelect = this._infoModal.iconSelect;
        let iconListWrapper = iconSelect.querySelector('.select-image-container');
        let activeIcon = iconSelect.querySelector('.select-image-active');

        if (!type) {
            iconListWrapper.classList.toggle('visible');
            return;
        }

        iconSelect.dataset['value'] = type;
        activeIcon.classList.remove(`icon-${currentType}`);

        if(validURL(type)){
            activeIcon.classList.add(`icon-custom`);
            activeIcon.style.backgroundImage = `url(${type})`;
        }else{
            activeIcon.classList.remove(`icon-custom`);
            activeIcon.classList.add(`icon-${type}`);
            activeIcon.style.backgroundImage = `none`;
        }

        this._infoModal.saveHandler();
    }

    _setActiveIcon(icon) {
        const iconSelect = this._infoModal.iconSelect;
              iconSelect.dataset['value'] = icon;

        const activeIcon = this._infoModal.iconSelect.querySelector('.select-image-active');
              activeIcon.classList.add(`icon-custom`);
              activeIcon.style.backgroundImage = `url(${icon})`;
    }

    _updateCustomFloorplanConfig(floorplanConfig) {
        let keys = Object.keys(floorplanConfig);
        keys.forEach((key) => {
            const frontend_config = JSON.parse(getCookie(this.frontendCompanyID) || '{}');

            if(!frontend_config || !frontend_config['custom']) return ;

            let custom = frontend_config['custom'][key];
            if(custom){
                floorplanConfig[key].splice(0, 0, custom);
            }
        })
    }

    _initFloorplanPanel(metrical) {
        const {e3plan: floorplanConfig, tourID} = this.config;
        this._updateCustomFloorplanConfig(floorplanConfig);
        floorplanConfig.floors = this.viewer && this.viewer.getFloornames();

        this._floorplanPanel = new E3PlanPanel(this.pannellumContainer,
            floorplanConfig,
            this.config.editable,
            this.e3plan_max_floors,
            metrical,
            {
                recreateFloorplan: this.recreateFloorplan.bind(this),
                recreateCurrentFloor: this.recreateCurrentFloor.bind(this,)
            });

        this._panel.on('before.event.trigger', (e) => {
            if (!this._floorplanPanel.isPreviewModeReadOnly()) this._floorplanPanel.togglePreviewMode();
            this._cleanUpFloorplanCloseCallback();
        });

        // bind events to e3panel
        this._floorplanPanel.on('switch', this._onSwitchMode.bind(this));
        this._floorplanPanel.on('add', this._onCreateFloorpoint.bind(this));
        this._floorplanPanel.on('reset', this._onResetFloorplan.bind(this));
        this._floorplanPanel.on('remove.area', this._removeArea.bind(this));
        this._floorplanPanel.on('change.floor', (floor) => {
            console.log('set floor:', floor);

            this.viewer.setFloor(floor);
            this._onPreview();
            this._debounceSavePlan();
        });
        this._floorplanPanel.on('set.room', () => { this.viewer.updateFloorplan();});
        this._floorplanPanel.on('detail.save', (detail) => {
            this.viewer.setFloorplanDetail(detail);
            this._onPreview();
            this._debounceSavePlan();
        });
        this._floorplanPanel.on('detail.save.cookie', (detail) => {
            if (!this.viewer.getVertexCount() || detail.custom) {
                delete detail.custom;
                this._saveDetailsToCookies(detail);
            }
        });
        this._floorplanPanel.on('add.floor', this._showAddFloorModal.bind(this));
        this._floorplanPanel.on('delete.floor', this._showDeleteFloorModal.bind(this));
        this._floorplanPanel.on('remove.layer', this._deleteFloorFromPanel.bind(this));
        this._floorplanPanel.on('remove.hole', this._deleteHole.bind(this));
        this._floorplanPanel.on('change.floors', this._changeFloors.bind(this));
        this._floorplanPanel.on('add.layer', this._addNewFloor.bind(this));
        this._floorplanPanel.on('select.layer', this._selectLayer.bind(this));
        this._floorplanPanel.on('set.layer.properties', this._setLayerProperties.bind(this));
        this._floorplanPanel.on('e3.planner.update.scene.properties', this._updateSceneProperties.bind(this));
        this._floorplanPanel.on('e3.planner.change.fontSize.layer', this.changeFontSizeLayer.bind(this));
        this._floorplanPanel.on('e3.planner.update.scene.color.properties', this._updateSceneColorProperties.bind(this));
        this._floorplanPanel.on('e3.planner.update.polygon.size', this._updatePolygonSize.bind(this));
        this._floorplanPanel.on('e3.planner.set.floor.params', this._changeFloorplanParams.bind(this));
        this._floorplanPanel.on('e3.planner.helpModal', this._e3HelpModal.bind(this));
        this._floorplanPanel.on('e3.planner.help', this._e3Help.bind(this));
        this._floorplanPanel.on('edit.floor', this._onEditFloorName.bind(this));
        this._floorplanPanel.on('editor', this._openFloorplanEditor.bind(this));
        this._floorplanPanel.on('update', (plan) => {
            if (!plan) return;
            this.viewer.updateFloorplan(plan);
        });
        this._floorplanPanel.on('debounce.save.plan', () => {
            this.saveFloorplanServer();
        });
        this._floorplanPanel.on('save.plan', (plan) => {
            this.viewer.setPlanPreview(plan);
            this._debounceSavePlan();
        });
        this._floorplanPanel.on('update.plan', () => {
            this.saveFloorplanLocal();
        });
        this._floorplanPanel.on('full.screen', this._onFloorplanFullScreen.bind(this));
        this._floorplanPanel.on('upgrade.plan', this._upgradePlan.bind(this));
        this._floorplanPanel.on('set.floor', this._setFloor.bind(this));
        this._floorplanPanel.on('ready', () => {
            if (this.viewer.isUpdatePreviewNeeded()) {
                this.viewer.updatePreview();
                this._floorplanPanel.generatePreview(this.viewer.getPlan(), true, this.viewer.getPlan());
            } else {
                this._floorplanPanel.generatePreview(this.viewer.getPlanPreview(), false, this.viewer.getPlan());
            }
        });

        this._floorplanPanel.on('show.3d', () => {
            this._on3DPlanClick();

            if (this._openFloorplanPanelBound) {
                this._cleanUpFloorplanCloseCallback();
                console.info('Double event removing');
            }

            this._openFloorplanPanelBound = this._openFloorplanPanel.bind(this);
            this._e3plan3D.on('model.hidden', this._openFloorplanPanelBound);
        });

        // set default values from floorplan scene
        this._floorplanPanel.setDetails(this._getFloorplanDetails(), undefined, undefined, true);
        this._floorplanPanel.setFloor(this.viewer.getCurrentFloor());

        if (!this.viewer.getVertexCount()) this._floorplanPanel.hideControl('add');
    }

    _getFloorplanDetails(){
        if (!this.viewer.getVertexCount() && this._defaultFloorplanDetails) {
                this.viewer.setFloorplanDetail(this._defaultFloorplanDetails);
        }

        return this.viewer.getFloorplanDetails();
    }

    _saveDetailsToCookies(details){
        details = _.cloneDeep(details)
        const opt = pick(details, ['height_lens', 'tripods', 'cameras']);
        const frontend_config = getCookie(this.frontendCompanyID) || JSON.stringify({});
        const methold = Object.keys(opt)[0];
        let newValue = merge(JSON.parse(frontend_config), {default: opt});

        if(opt[methold] && opt[methold].id === '-1') newValue = merge(newValue, {custom: opt});

        setCookie(this.frontendCompanyID, JSON.stringify(newValue));
    }

    isFloorPlanActive(){
        const e3plan_json = this.viewer.getPlan();
        const countVertices = e3plan_json ? this.countVertices(e3plan_json.layers) : 0;

        return countVertices && e3plan_json && e3plan_json.height && e3plan_json.width;
    }

    countVertices(layers){
        return Object.values(layers).reduce((prev, next) => prev + Object.values(next.vertices).length, 0);
    }

    recreateFloorplan(showMsg) {
        return this.viewer.recreateFloorplan(showMsg)
    }

    recreateCurrentFloor() {
        return this.viewer.recreateCurrentFloor();
    }

    _openFloorplanPanel() {
        if (
            this._floorplanPanel &&
            this._floorplanPanel.isPreviewModeReadOnly() &&
            this._floorplanPanel.isShown()
        ) {
            this._floorplanPanel.togglePreviewMode();
        }

        this._cleanUpFloorplanCloseCallback()
    }

    _cleanUpFloorplanCloseCallback() {
        if (this._openFloorplanPanelBound && this._e3plan3D) {
            this._e3plan3D.off('model.hidden', this._openFloorplanPanelBound);
            this._openFloorplanPanelBound = null;
        }
    }

    _setFloor(floors) {
        this._floorplanPanel.updateFloors(this.viewer.getFloornames(), floors || this.viewer.getCurrentFloor());
        this.viewer.setFloor(floors || this.viewer.getCurrentFloor());
        this._onPreview();
        this._debounceSavePlan();
    }

    _upgradePlan(data) {
        this._setFloor();
        this._fireEvent('upgrade.plan', data.plans);
    }

    _initInfoModalAlert() {
        this._infoModal.alert = {
            container: this._infoModal.container.querySelector('.e3-viewer-poi-alert'),
            message: this._infoModal.container.querySelector('.e3-viewer-poi-alert-message'),
            confirm: this._infoModal.container.querySelector('.e3-viewer-poi-alert_confirm'),
            cancel: this._infoModal.container.querySelector('.e3-viewer-poi-alert_cancel'),
        };
        this._infoModal.alert.cancelHandler = this._hideInfoModalAlert.bind(this);
        this._infoModal.alert.cancel.addEventListener('click', this._infoModal.alert.cancelHandler);
    }

    _isBtnDisabled(button) {
        return this._infoModal[button + 'Button'].getAttribute('disabled');
    }

    _selectLayer(id) {
        this.viewer.selectLayer(id);
        this._onPreview();
        this._debounceSavePlan();
    }

    _addNewFloor(value, prevLayerId, isNeedMove = true) {
        let altitude = this.viewer.getNewFloorAltitude(prevLayerId);
        this.viewer.setFloor({label: value, id: shortid.generate(), altitude, isNeedMove});
        this._floorplanPanel.updateFloors(this.viewer.getFloornames(), this.viewer.getCurrentFloor());
        this._onPreview();
        this._debounceSavePlan();
    }

    _renameLayer() {
        this._onPreview();
        this._debounceSavePlan();
    }

    _onAddNewFloorSubmit(input, prevLayerId, e) {
        e.preventDefault();

        if (input.value.replace(' ','')) {
            let altitude = this.viewer.getNewFloorAltitude(prevLayerId);
            this.viewer.setFloor({label: input.value, id: shortid.generate(), altitude, isNeedMove: true});
            this._floorplanPanel.updateFloors(this.viewer.getFloornames(), this.viewer.getCurrentFloor());
            this._onPreview();
            this.saveFloorplanServer();
            this._debounceSavePlan();
        }
    }

    _removeArea(areaID) {
        if(this.viewer.isActiveArea(areaID)){
            this._floorplanPanel.hideControl('add');
            this._floorplanPanel.switchControl('add', true);
            this._clearArea(true);
        }else{
            this.viewer.removeArea(areaID);
        }

        this._onPreview();
        this._debounceSavePlan();
    }

    _clearArea(enable) {
        if(enable && this.viewer.getVertexCount() > 0){
            this.viewer.clearArea(true);
            this._floorplanPanel.hideControl('add');
            this._floorplanPanel.showTipsStep(1);

            this._onPreview();
        }
        this.viewer.requestFloorpoint(enable);
        this.container.classList[enable ? 'add' : 'remove']('floorplan-mode');
    }

    _onResetFloorplan(enable) {
        this.viewer.resetFloorplan();
    }

    _onCreateFloorpoint(enable) {
        let promise = Promise.resolve();

        // if (enable) {
        //     promise = this.viewer.recreateFloorplan();
        // }

        promise
            .then(() => {
                if(enable){
                    this._saveDetailsToCookies(this._getFloorplanDetails());
                    this._clearArea(enable);
                    this._floorplanPanel.setDetails(this._getFloorplanDetails(), undefined, undefined, true);
                }else{
                    this.viewer.requestFloorpoint(enable);
                    this.container.classList[enable ? 'add' : 'remove']('floorplan-mode');
                }
            })
            .catch((e) => {
                console.error(e)
            })
    }

    vr(){
        super.vr();
        if(this._floorplanPanel) {
            this._hideFloorplan();
        }
    }

    _onE3PlayStart() {
        if(this._floorplanPanel) {
            this._hideFloorplan();
        }
        super._onE3PlayStart();
    }

    _updateSceneProperties(data) {
        this.viewer.updateSceneProperties(data);
        this._onPreview();
        this._debounceSavePlan();
    }

    changeFontSizeLayer(data) {
        this.viewer._changeFontSizeLayer(data);
    }

    _updateSceneColorProperties(data) {
        this.viewer.updateCurrentColor(data.patternColor, data.areaId);
        this._onPreview();
        this._debounceSavePlan();
    }

    _updatePolygonSize(data) {
        this.viewer.updatePolygonSize(data);
        this._onPreview();
        this._debounceSavePlan();
    }

    _setLayerProperties(data) {
        this.viewer.setCurrentFloorName(data.name, data.id);
        this.viewer.setCurrentFloorAltitude(data.altitude, data.id);
        this._onPreview();
        this._debounceSavePlan();
    }

    _e3HelpModal() {
        this._fireEvent('e3.planner.helpModal');
    }
    _e3Help() {
        this._fireEvent('e3.planner.help');
    }

    _changeFloorplanParams(data) {
        this.viewer.changeFloorplanParams(data);
        this._onPreview();
        this._debounceSavePlan();
    }

    _onEditFloorName(e) {
        this.viewer.setCurrentFloorName(e.name, e.id);
        this._debounceSavePlan();
    }

    _onEditorChanges(delta, oldDelta, source) {
        const isAudio = delta.ops.find(({insert}) => insert?.audio);
        const current = this._infoModal.iconSelect.dataset.value;

        if (isAudio) {
            this._infoModal.targetNode.classList.add('icon-sound');
            this._changeInfoIcon('sound', current);
        } else if (delta.ops.length === 1){
            const container = delta.ops[0].insert;
            if(!container) return ;

            let type = Object.keys(container)[0];

            if (type === '0') {
                type = 'text';
            }

            switch(type) {
                case 'image':
                    this._changeInfoIcon('camera', current);
                break;
                case 'video':
                    if (container.video.match(/google\.com\/maps/)) {
                        this._changeInfoIcon('map', current);
                    } else {
                        this._changeInfoIcon('video', current);
                    }
                break;
                case 'iframe':
                case 'text':
                    this._changeInfoIcon('info', current);
                break;
                default:
                    this._changeInfoIcon('info', current);
            }
        }
      
        if (source !== 'user') return;


        if (this._isBtnDisabled('save')) {
            this._toggleAccess('save', true);
            // this._needToBeSaved = true;
        }
    }

    _onFloorplanAddPoint(event) {
        let {count} = event;

        if (count > 0) {
            this._floorplanPanel.showTipsStep(2);
        }
        if (count > 1) {
            this._floorplanPanel.showControl('add');
        }
    }

    _onFloorplanFullScreen(e) {
        this._fireEvent('floorplan.full.screen', e.active);
        if(!e.active) {
            this._panel._removeActionFloorplanListener();
            this._selectLayer();
            const id = this._getLayerId();
            this._floorplanPanel.setFloor({id});
        }
    }

    _getLayerId(){
        return this.viewer.getLayerId();
    }

    _onLayerManagerPreview() {
        if(this._floorplanPanel) {
            const plan = this.viewer.getPlan();
            const planPreview = this.viewer.getPlanPreview();
            planPreview.width = plan.width;
            planPreview.height = plan.height;
            planPreview.selectedLayer = plan.selectedLayer;
            Object.values(plan.layers).forEach((layer) => {
                if(!Object.keys(planPreview.layers).includes(layer.id)){
                    planPreview.layers[layer.id] = layer;
                }else{
                    planPreview.layers[layer.id].name = plan.layers[layer.id].name;
                    planPreview.layers[layer.id].altitude = plan.layers[layer.id].altitude;
                    if(Object.keys(planPreview.layers[layer.id].areas).length !== Object.keys(plan.layers[layer.id].areas).length){
                        planPreview.layers[layer.id].areas = plan.layers[layer.id].areas;
                    }
                }
            })
            this._floorplanPanel.generatePreview(planPreview, true, this.viewer.getPlan());
        }
    }

    _onPreview() {
        if (!this._debouncePreview) {
            this._debouncePreview = debounce(()=> {
                if(this._floorplanPanel) {
                    if (this.viewer.getPlanPreview().customUpdate) {
                        let plan = _.cloneDeep(this.viewer.getPlan());
                        let preview = _.cloneDeep(this.viewer.getPlanPreview());
                        this._mergePlans(plan, preview);
                        this._floorplanPanel.generatePreview(plan, true, this.viewer.getPlan());
                    } else {
                        this._floorplanPanel.generatePreview(this.viewer.getPlan(), true, this.viewer.getPlan());
                    }
                }
            }, 100)
        }
        this._debouncePreview();
    }

    _mergePlans(plan, preview){
        plan.customUpdate = preview.customUpdate;
        plan.width = preview.width;
        plan.unit = preview.unit;
        plan.metrical = preview.metrical;
        plan.height = preview.height;
        for(let layer in plan.layers){
            for(let layerPreview in preview.layers){
                if(plan.layers[layer].id == preview.layers[layerPreview].id){
                    plan.layers[layer].fontSize = preview.layers[layerPreview].fontSize;
                    plan.layers[layer].angle = preview.layers[layerPreview].angle;
                    plan.layers[layer].selected = preview.layers[layerPreview].selected;
                    mergeVertices(plan.layers[layer].vertices, preview.layers[layerPreview].vertices);
                    mergeAreas(plan.layers[layer].areas, preview.layers[layerPreview].areas);
                    mergeItems(plan.layers[layer], preview.layers[layerPreview]);
                    mergeHoles(plan.layers[layer], preview.layers[layerPreview]);
                    mergeLines(plan.layers[layer], preview.layers[layerPreview]);
                    mergeMergeAreas(plan.layers[layer], preview.layers[layerPreview]);
                }
            }
        }
        function mergeAreas(plan, preview) {
            for(let area in plan){
                for(let areaPreview in preview){
                    if(area == areaPreview){
                        plan[area].angle = preview[areaPreview].angle;
                        plan[area].properties.fontSize = preview[areaPreview].properties.fontSize || FONT_SIZE;
                        plan[area].properties.area = preview[areaPreview].properties.area || 0;
                        plan[area].properties.length = preview[areaPreview].properties.length || 0;
                        plan[area].properties.width = preview[areaPreview].properties.width || 0;
                        plan[area].properties.patternColor = preview[areaPreview].properties.patternColor;
                        plan[area].properties.scene.camera = preview[areaPreview].properties.scene.camera;
                        plan[area].properties.scene.ceiling = preview[areaPreview].properties.scene.ceiling;
                        plan[area].properties.scene.rotateDirection = preview[areaPreview].properties.scene.rotateDirection;
                    }
                }
            }
        }
        function mergeVertices(plan, preview) {
            for(let vertice in plan){
                for(let verticePreview in preview){
                    if(vertice == verticePreview){
                        plan[vertice].x = preview[verticePreview].x;
                        plan[vertice].y = preview[verticePreview].y;
                        plan[vertice]['2d'] = preview[verticePreview]['2d'];
                    }
                }
            }
        }
        function mergeItems(plan, preview) {
            if (!plan.items) plan.items = {};

            Object.keys(preview.items)
                .forEach((item) => plan.items[item] = preview.items[item]);
        }

        function mergeHoles(plan, preview) {
            Object.keys(preview.holes)
                .forEach((hole) => plan.holes[hole] = preview.holes[hole]);
        }

        function mergeLines(plan, preview) {
            Object.keys(preview.lines)
                .forEach((line) => {
                    if(plan.lines[line] && preview.lines[line]){
                        plan.lines[line].properties.visible = preview.lines[line].properties.visible
                    }
                });
        }

        function mergeMergeAreas(plan, preview) {
            if (!plan.mergeAreass) plan.mergeAreas = {};
            if (!preview.mergeAreas) preview.mergeAreas = {};

            Object.keys(preview.mergeAreas)
                .forEach((item) => plan.mergeAreas[item] = preview.mergeAreas[item]);
        }
    }

    _onPreviewUpdated() {
        // if(this._floorplanPanel) {
        //     this._floorplanPanel.generatePreview(this.viewer.getPlanPreview(), false);
        // }
    }

    _onSceneChange(scene) {
        super._onSceneChange(scene);
        if(this._floorplanPanel) {
            if (this.viewer.getVertexCount()) {
                this._prevFloorplan = this.viewer.getFloorplanDetails();
            }
           this._floorplanPanel.showControl('add');
        }
    }

    _onSceneLoad() {
        super._onSceneLoad();
    }

    _onSceneChangeLoad() {
        super._onSceneChangeLoad();
        this.updateDetails();
    }

    updateDetails(){
        if (this._floorplanPanel && this._floorplanPanel.isShown()) {
            // this._floorplanPanel.setFloor(this.viewer.getCurrentFloor());
            this._floorplanPanel.clearPreview();
            if (!this.viewer.getVertexCount()) {
                this._floorplanPanel.setDetails(this._getFloorplanDetails());
                if (this._prevFloorplan)  this._setPrevFloorplan();
                this._floorplanPanel.hideControl('add');
                this._floorplanPanel.switchControl('add', true);
                this._floorplanPanel.showTipsStep(1);
            } else {
                this._floorplanPanel.setDetails(this._getFloorplanDetails());
                this._floorplanPanel.switchControl('add', false);
                this._floorplanPanel.hideTipStep();
            }

            // this.viewer.recalculateAdjustPoints();
        }
    }

    _onSwitchMode() {
        if(this.viewer.getVertexCount() > 0){
            this.viewer.clearArea();
        }
    }

    _onTitleChanges(e) {
        if (e.target.value && e.target.value.length > 20 && e.keyCode !== 8 && e.keyCode !== 46) {
            e.preventDefault();
            e.target.value = e.target.value.substr(0, 20);
        }
        if (this._isBtnDisabled('save')) {
            this._toggleAccess('save', true);
        }
        if (!this._needToBeSaved) this._needToBeSaved = true;

        this._setPoiTitle(e.target.value);
    }

    _setPoiTitle(string) {
        let poiTitle = this._infoModal.targetNode.querySelector('.pnlm-hotspot-title');

        if (!poiTitle) return;

        poiTitle.innerText = string;
    }

    _onToggleFloorPlan() {
        this._floorplanPanel.switchControl('add');
    }

    _openFloorplanEditor() {
        this._fireEvent('floorplan.edit', this.viewer.getPlan());
    }

    _prepareHotspot(hotSpot) {
        let hs = super._prepareHotspot(hotSpot);
        if (['floor', 'wall'].indexOf(hotSpot.type) > -1) {
            hs.cssClass = `hotspot-floor`;
            hs.id = hotSpot.id;
            hs.type = 'floor';
        }
        return hs;
    }

    extractPoitLang(html) {
        if (!this.isJSON(html)) return JSON.stringify([]);
        const obj = JSON.parse(html);
        const langs = Object.keys(obj).filter(lang => this._onE3TourCheckContent(obj[lang]));
        return JSON.stringify(langs);
    }

    _preparePoiToSend(files) {
        return {
            poiID: this._infoModal.id,
            poi: this._infoModal.title,
            html: !this._infoModal.html.length ? '<p></p>' : this._infoModal.html,
            icon: files || this._infoModal.icon,
            size: this._infoModal.size || 'balloon',
            order: this._infoModal.order,
            lang: this.extractPoitLang(this._infoModal.original)
        }
    }

    _savePoiCallback(res, infoID) {
        if (!res) {
            // todo: show error
            this._waitForSaving = false;
            return;
        }
        infoID = infoID || this._infoModal.id;
        this._toggleAccess('save', false);
        this._showInfoModalLoader(false);
        // this.reinitViewer = true;
        this._waitForSaving = false;
        this._needToBeSaved = false;
        let {id, title, icon, size} = res.data;
        this._changePoiData(infoID, id, {title, icon, size});
    }

    _changePoiData(infoID, htmlID, options = {}) {
        this.viewer.changeHotSpotData(infoID, htmlID, options);
    }

    _showAddFloorModal(e) {
        let wrapper = document.createElement('form');
        wrapper.classList.add('add-floor-modal');
        wrapper.id = 'add-floor-modal';
        let p = document.createElement('p');
        p.innerText = 'Type name of new floor';
        let input = document.createElement('input');
        input.placeholder = 'Floor...';
        let btnWrapper = document.createElement('div');
        btnWrapper.classList.add('form-buttons');
        wrapper.appendChild(p);
        wrapper.appendChild(input);

        let btn = document.createElement('button');
        btn.type = 'submit';
        btn.classList.add('modal-action-btn');
        btn.innerText = 'Add';

        btnWrapper.appendChild(btn);
        wrapper.appendChild(btnWrapper);

        let modal = this._modalService.showCreatedModal('add.floor', wrapper, true, {
            'add-floor-modal' : {
                event: 'submit',
                handler: this._onAddNewFloorSubmit.bind(this, input, e.prev),
                close: true
            }});
        // }, [
        //     {
        //         name: 'add.floor',
        //         type: 'click',
        //         element: btn,
        //         handler: () => wrapper.submit()
        //     }
        // ]);

        modal.querySelector('input').focus();

        this._floorplanPanel.setFloor(this.viewer.getCurrentFloor());
    }

    showDeleteFloorModal(id) {
        return this._showDeleteFloorModal(id);
    }

    _showDeleteFloorModal(id) {
        return this._modalService.confirm('Do you really want to delete the floor?', this._deleteFloorFromPanel.bind(this, id), 'delete-floor');
    }

    _showInfo(id, htmlURL, title = '', icon = '', infoDiv, event, size, order) {
        if (this._waitForSaving) return;

        if (event && event.stopPropagation)
            event.stopPropagation();

        if (this._poiAsyncAction) return;

        if (this._infoModal) {

            if (this._infoModal.id !== id) {
                this._infoModal.closeHandler(event);
            } else {
                this._toggleInfoModal();
                this._initMsgListener(id);

                return;
            }
        }


        this._poiAsyncAction = this._poiAsyncAction || Promise.resolve();

        return this._poiAsyncAction.then(() => {
            let modalContainer = document.createElement('div');

            if (this._infoModal) this.destroyInfoModal();

            modalContainer.classList.add('e3-viewer-poi-info-container');
            this._infoModal = {
                container: modalContainer,
                id,
                targetNode: infoDiv,
                size: size,
                order,
                oldSize: size,
                loaderClassName:'.e3-viewer-poi-loader',
                events: []
            };
            this._infoModal.container = modalContainer;
            infoDiv.appendChild(this._infoModal.container);
            this._initMsgListener(id);

            return this._showInfoContent(this._infoModal.container, htmlURL, id, title, icon, size);
        });
    }

    // _toggleVisibleAudioButton(html) {
    //     const isEmpty = html.match(/<p>.*?<\/p>/g).length;
    //     const isAudio = html.match(/<audio\b[^>]*\bclass="ql-audio"[^>]*>.*?<\/audio>/g);

    //     this._infoModal.getMenuButton('audio').classList[!isAudio && isEmpty ? 'add' : 'remove']('hidden');
    // }

    async _showInfoContent(container, htmlUrl, id, title = '', icon, size) {
        if (!this.config.editable) {
            return super._showInfoContent(container, htmlUrl);
        }
        
        if (this._player && this._player.isPlaying()) {
            this._onE3PlayPause(true);
        }

        icon = icon || 'info';

        this._fireEvent('poi.editor.open');
        if (!this.poiEditor || this._infoModal.type !== 'editor') await this._initEditor(container);
        // container = this._calculatePOIEditorPosition(container, this._infoModal.targetNode, this.container);
        this._hideInfoModalAlert();
        this._infoModal.id = id;
        this._infoModal.htmlUrl = htmlUrl;
        this._infoModal.html = '';
        this._infoModal.title = title;
        this._infoModal.icon = icon;
        this._infoModal.hidden = true;
        this._infoModal.size = size || 'balloon';
        this._infoModal.oldSize = size || 'balloon';
        container.querySelector('.e3-viewer-poi-title-field').value = title;
        this._infoModal.iconSelect.dataset['value'] = icon;
        const activeIcon = this._infoModal.iconSelect.querySelector('.select-image-active');
        if(validURL(icon)){
            activeIcon.classList.add(`icon-custom`);
            activeIcon.style.backgroundImage = `url(${icon})`;
            activeIcon.style.backgroundSize = `contain`;
            activeIcon.style.borderRadius = `30px`;
        }else{
            activeIcon.classList.remove(`icon-custom`);
            activeIcon.classList.add(`icon-${icon}`);
            activeIcon.style.backgroundImage = `none`;
        }
        if (!htmlUrl) {
            // container.classList.add('show-info-editor');
            this._toggleInfoModal();
            this.poiEditor.on('text-change', this._infoModal.editorChangeHandler);
            this._infoModal.original = '<p></p>';
            this._setPoeContainer(container);
            container.querySelector('.ql-editor').focus();
            this._poiAsyncAction = null;
            this._infoModal.hidden = false;

            return Promise.resolve();
        } else {
            // container.classList.add('show-info-editor');
            this._showInfoModalLoader(true);
            this._poiAsyncAction = this._helperService.ajaxCall(htmlUrl)
                .then(function (html) {
                    this._infoModal.original = html;
                    this._setPoeContainer(container);
                    this._toggleInfoModal();

                    this._showInfoModalLoader(false);
                    // this._toggleVisibleAudioButton(html);

                    let timeout = new Promise((resolve, reject) => {
                        setTimeout(function () {
                            this.poiEditor
                                .off('text-change', this._infoModal.editorChangeHandler)
                                .on('text-change', this._infoModal.editorChangeHandler);
                            this._toggleAccess('save', false);
                            this._infoModal.html = container.querySelector('.ql-editor').innerHTML;
                            container.querySelector('.ql-editor').focus();
                            this._poiAsyncAction = null;
                            this._infoModal.hidden = false;
                            this.poiEditor.history.clear();
                            this.poiEditor.history.checkButtonsState();
                            this._focusHotspot(htmlUrl, container);

                            // Auto-play audio/video element when museum guide is waiting for media end
                            const guideMedia = container.querySelector('audio, video');
                            if (guideMedia && this._pendingInfoResolve) {
                                guideMedia.addEventListener('ended', () => this._resolvePendingInfo(), { once: true });
                                guideMedia.play().catch(() => {});
                            }

                            // Auto-play audio/video/YouTube/Vimeo when museum guide is waiting for media end
                            this._setupGuideMediaEnd(container);

                            resolve();
                        }.bind(this), 100);
                    });

                    return timeout;
                }.bind(this))
                .catch((err) => {
                    this._modalService.showCreatedModal('alert', this._translateService.translate('INFO_ERROR'), true, {
                        'chat-modal-close': () => {
                            setTimeout(() => {
                                this._showInfoModalLoader(false);
                                this._poiAsyncAction = null;
                                this._infoModal.hidden = false;
                                this.poiEditor.history.clear();
                                this.poiEditor.history.checkButtonsState();
                            }, 0)

                            return true;
                        }
                    })
                });
        }
    }

    _showInfoModalAlert(message, confirmCallback) {
        if (!this._infoModal.alert) this._initInfoModalAlert();

        this._infoModal.alert.message.innerHTML = message;
        this._infoModal.alert.confirmHandler = confirmCallback.bind(this);
        this._infoModal.alert.confirm.addEventListener('click', this._infoModal.alert.confirmHandler);
        this._infoModal.alert.container.classList.add('show');
    }

    _toggleAccess(btn, setDisabled) {
        setDisabled = typeof setDisabled === "boolean" ? setDisabled : this._isBtnDisabled(btn);

        if (setDisabled) this._infoModal[btn + 'Button'].removeAttribute('disabled');
        else this._infoModal[btn + 'Button'].setAttribute('disabled', 'disabled');
    }

    convertToPannellum(config, autorotate) {
        // needed in case of deleting some scene via admin part of app from current config
        // so we need update floorplan config relations
        config.e3plan_json = this._checkE3PlanConfigIntegrity(config.e3plan_json, config.scenes);
        let pannellumJson = super.convertToPannellum(config, autorotate);
        // pannellumJson.floorplan = config.floorplan;

        return pannellumJson;
    }

    async deletePoi(e) {
        if(e && e.stopPropagation) e.stopPropagation();

        this._poiAsyncAction = Promise.resolve();

        await this._reorderInfo(+this._infoModal.order);
        this._fireEvent('poi.delete', this._preparePoiToSend());
        this._hideInfoModalAlert();
        this._destroyInfoModalAlert();
        this._showInfoModalLoader(true);
    }

    _reorderInfo(deleteOrder) {
        return new Promise((res, rej) => {
            try {
                const {hotspots} = this._getCurrentScene();
                const poiHotspots = hotspots
                    .filter(({poiID}) => poiID)
                    .filter((hotsot) => +hotsot.order > deleteOrder)
                    .sort((a, b) => a.order - b.order);

                poiHotspots
                    .forEach(async ({order, poiID}, ind) => {
                        await this._orderHotspotUpdate(poiID, +order - 1);
                    })
                    this._fireEvent('poi.reinit');
                    this._fireEvent('poi.editor.close');

                res();
            } catch (e) {
                console.error(e);
            }
        })
    }

    destroy() {
        super.destroy();
        if (this._floorplanPanel) {
            this._floorplanPanel.off();
            this._panel.off('before.event.trigger');
            this._floorplanPanel.destroy();
        }
    }

    destroyInfoModal() {
        if (!this.config.editable) {
            super.destroyInfoModal();
            return;
        }
        if (!this._infoModal) return;

        this._destroyInfoModalAlert();

        this.poiEditor.off('text-change', this._infoModal.editorChangeHandler);

        this._infoModal.titleField.removeEventListener('input', this._infoModal.titleChangeHandler);

        this._unbindInfoModalEvenets();

        this._infoModal.container.parentNode.removeChild(this._infoModal.container);
        this._infoModal.events.forEach(({event, callback, action}) => {
            event.removeEventListener(action, callback);
        })

        delete this._infoModal;
        delete this.poiEditor;
    }

    initControls() {
        super.initControls();

        this._panel.on('ql-street-open', this._onOpenGmapStreet.bind(this));
        this._panel.on('tour-info.save', this._onE3TourInfoSave.bind(this));
        this._panel.on('tour-info.delete', this._onE3TourInfoDelete.bind(this));
        this._panel.on('open.content', this._onE3OpenContent.bind(this));
        this._panel.on('floorplans_3d', this._onE3OpenContent.bind(this));
    }

    _onOpenGmapStreet({editor}) {
        const poiEditor = editor || this.poiEditor;
        this.E3GoogleMap = new E3GoogleMap(this.config.api.google_api.key);
        this._modalService._modalZIndex = 99999;
        this._modalService.showCreatedModal('google-map',  this.E3GoogleMap.container(), true);

        this.E3GoogleMap.on('e3.google.street.close', () => {
            this._poiAsyncAction = Promise.resolve();
            this._modalService.close('google-map');
            setTimeout(() => this._poiAsyncAction = null, 2000)
        });

        this.E3GoogleMap.on('e3.google.street', (src) => {
            const index = poiEditor.getSelection() ? poiEditor.getSelection().index : 0;
            poiEditor.insertEmbed(index, 'video', src.map);
            poiEditor.clipboard.dangerouslyPasteHTML(index+1, '<p></p>');
            poiEditor.insertEmbed(index+2, 'video', src.street);
            poiEditor.clipboard.dangerouslyPasteHTML(index+3, '<p>&nbsp;</p>');
            this._poiAsyncAction = Promise.resolve();
            this._modalService.close('google-map');
            setTimeout(() => this._poiAsyncAction = null, 2000)
        })
    }

    updateScenePanorama(params) {
        return this.viewer.updateScenePanorama(params);
    }

    initPannellum(json) {
        super.initPannellum(json);
        if(this.viewer.updateScenePreview()) this._debounceSavePlan();
        this.viewer.on('floorplan.edit.finish', (updateToogle) => {
            if(!updateToogle) this._onToggleFloorPlan();
            this._floorplanPanel.hideTipStep();
            this._floorplanPanel.showTipsStep(3);
            this._drawing = true;
            this._debounceSavePlan();
        });
        this.viewer.on('floorplan.edit.details', (isTopPoint) => {
            this._floorplanPanel.setDetails(this._getFloorplanDetails(), isTopPoint, true);
            this._debounceSavePlan();
        });
        this.viewer.on('floorplan.panel.hide', () => {
            if (this._floorplanPanel.getControlValue)
                this._floorplanPanel.switchControl('add', false);
        });
        this.viewer.on('preview', this._onPreview.bind(this));
        this.viewer.on('hotspotDrag', this._debounceSavePlan.bind(this));
        // this.viewer.on('preview.updated', this._onPreviewUpdated.bind(this));
        this.viewer.on('floorpoint.add', this._onFloorplanAddPoint.bind(this));
        this.viewer.on('add', this._onAddNewFloorpoint.bind(this));
        this.viewer.on('floorpoint.start.adjust', this._onStartAdjustFloorpoint.bind(this));
        this.viewer.on('keyDown', this._keyDown.bind(this));
        this.viewer.on('keyUp', this._keyUp.bind(this));
        this.viewer.on('before.change.scene', this._beforeChangeScene.bind(this));
    }

    _beforeChangeScene(e) {
       this.saveFloorplanServer();
    }

    _keyUp(e) {
        let keynumber = e.which || e.keycode;

        if(keynumber == 18){
            this._toggleFloorplanSnap(true);
        }
    }

    _keyDown(e){
        let keynumber = e.which || e.keycode;

        if(keynumber == 18){
            this._toggleFloorplanSnap(false);
        }
    }

    _toggleFloorplanSnap(e, snap){
        if(e && e instanceof Event) {
            e.preventDefault();
        }

        this.viewer.toggleFloorplanSnap(snap);
    }


    _onStartAdjustFloorpoint(){
        this._floorplanPanel.showTipsStep(4);
    }

    _onAddNewFloorpoint(value){
        this._floorplanPanel.updateControllsValue('add', value);
        this._onCreateFloorpoint(value);
    }

    _onCancelPoi() {
        if (this._waitForSaving || this._modalService.checkIfModalPresent('google-map')) {
            return Promise.resolve();
        }

        if (this._infoModal.container.querySelector('.ql-editor').innerHTML !== this._infoModal.html || this._needToBeSaved || this._infoModal.oldSize !== this._infoModal.size) {
            return this._savePoi()
                .then(() => {
                    this._toggleInfoModal();
                    this._infoModal.targetNode.classList.remove(`pnlm-info-${(this._infoModal.size)}`);
                    this._infoModal.targetNode.classList.remove('active');
                })
        } else {
            this._toggleInfoModal();
            this._infoModal.targetNode.classList.remove(`pnlm-info-${(this._infoModal.size)}`);
            this._infoModal.targetNode.classList.remove('active');

            return ;
        }

    }

    _toggleInfoModal() {
        this._audioInfoListener.autoPlay(this._infoModal.hidden);

        if (this._infoModal.hidden) {

            this._infoModal.targetNode.classList.add('e3-poi-editing');

            this._infoModal.hidden = false;
            this._infoModal.targetNode.classList.toggle(`pnlm-info-${this._infoModal.size}`);
            this._infoModal.targetNode.classList.add('active');

            if(this._infoModal.size === 'fullscreen'){
                this._toggleLogo();
                this._toogleCloseButton(false);
            }

            this.viewer.toggleKeyboardListeners(false);
            updateInfoIconStyle();

            this._bindInfoModalEvents();
            this._fireEvent('poi.editor.open');

            const enableModal = () => {
                this._infoModal.container = this._calculatePOIEditorPosition(this._infoModal.container, this._infoModal.targetNode, this.container);
                this._infoModal.container.classList.add('show-info-editor');
            }
            this._enableVideoInfoModal(this._infoModal.container)
                .then(() => {
                    enableModal();
                    // Re-setup media end handler when guide re-opens same hotspot
                    if (!this._infoModal._ytHandler && !this._infoModal._vimeoHandler) {
                        this._setupGuideMediaEnd(this._infoModal.container);
                    }
                })
                .catch((err) => {
                    console.error(err);
                })
        } else {
            this._disableVideoInfoModal();

            return this._closeInfoModal();
        }
    }

    _closeInfoModal(){
        this._unbindInfoModalEvenets();
        updateInfoIconStyle();

        return this._animateHideInfoModal().then(() => {
            this._infoModal.hidden = true;

            this._hideInfoModal();
            this.viewer.toggleKeyboardListeners(true);

            this._poiAsyncAction = null;

            return Promise.resolve();
        });
    }

    _bindInfoModalEvents() {
        const draggingThreshold = 4;

        this._infoModal.stopPropagation = e => e.stopPropagation();

        // close handler also disables 'mousemove' event on container
        this._infoModal.closeHandler = (event, destroy = false) => {
            if (this._poiAsyncAction) return;
            this.container.removeEventListener('mousemove', this._infoModal.removeCancelEventListener, false);
            delete this._infoModal.dragging;

            this._resolvePendingInfo();
            this._poiAsyncAction = this._onCancelPoi();
        };

        // disables 'click' handler from container during scene panning
        // Store previous screenX/screenY somewhere outside of callback
        let prevX = 0;
        let prevY = 0;

        this._infoModal.removeCancelEventListener = (e) => {
            var movementX = (prevX ? e.screenX - prevX : 0);
            var movementY = (prevY ? e.screenY - prevY : 0);

            prevX = e.screenX;
            prevY = e.screenY;

            this._infoModal.dragging.x += movementX;
            this._infoModal.dragging.y += movementY;

            let {x, y} = this._infoModal.dragging;

            if (Math.abs(x) > draggingThreshold || Math.abs(y) > draggingThreshold) {
                this.container.removeEventListener('click', this._infoModal.closeHandler, {capture: false, once: true});
                this.container.removeEventListener('mousemove', this._infoModal.removeCancelEventListener, false);

                delete this._infoModal.dragging;
            }
        };

        // add mousedown listener for handling outbox click
        this._infoModal.onOutboxClick = (e) => {
            this._infoModal.dragging = {x:0, y:0};
            this.container.addEventListener('mousemove', this._infoModal.removeCancelEventListener, false);
            this.container.addEventListener('click', this._infoModal.closeHandler, {capture: false, once: true})
        };

        this.container.addEventListener('mousedown', this._infoModal.onOutboxClick);

        this._infoModal.toolbarContainer.addEventListener('mousedown', this._infoModal.stopPropagation, {capture: false, passive: true});
        this._infoModal.editorContainer.addEventListener('mousedown', this._infoModal.stopPropagation, {capture: false, passive: true});
        this._infoModal.editorContainer.addEventListener('mousewheel', this._infoModal.stopPropagation, false);

        // Touch device bindings
        this.container.addEventListener('touchstart', this._infoModal.onOutboxClick);
        this._infoModal.toolbarContainer.addEventListener('touchstart', this._infoModal.stopPropagation, false);
        this._infoModal.editorContainer.addEventListener('touchstart', this._infoModal.stopPropagation, false);

        // Is a case for touch devices
        this._infoModal.toolbarContainer.addEventListener('click', this._infoModal.stopPropagation, false);
        this._infoModal.editorContainer.addEventListener('click', this._infoModal.stopPropagation, false);

        // Firefox scrolling event
        this._infoModal.editorContainer.addEventListener('DOMMouseScroll', this._infoModal.stopPropagation, false);
    }

    _unbindInfoModalEvenets() {
        this._infoModal.editorContainer.removeEventListener('click', this._infoModal.stopPropagation, false);
        this._infoModal.toolbarContainer.removeEventListener('click', this._infoModal.stopPropagation, false);
        this._infoModal.editorContainer.removeEventListener('mousedown', this._infoModal.stopPropagation, false);
        this._infoModal.toolbarContainer.removeEventListener('mousedown', this._infoModal.stopPropagation, false);
        this._infoModal.editorContainer.removeEventListener('mousewheel', this._infoModal.stopPropagation, false);
        this._infoModal.editorContainer.removeEventListener('DOMMouseScroll', this._infoModal.stopPropagation, false);

        this.container.removeEventListener('mousemove', this._infoModal.removeCancelEventListener, false);
        this.container.removeEventListener('click', this._infoModal.closeHandler, {capture: false, once: true});
        this.container.removeEventListener('mousedown', this._infoModal.onOutboxClick);

        this.container.removeEventListener('touchstart', this._infoModal.onOutboxClick);
        this._infoModal.toolbarContainer.removeEventListener('touchstart', this._infoModal.stopPropagation, false);
        this._infoModal.editorContainer.removeEventListener('touchstart', this._infoModal.stopPropagation, false);

        this._destroyMsgListener();
    }

    onDeletePoi() {
        this._showInfoModalAlert('Are you sure you want to delete this Info?', this.deletePoi);
    }

    _savePoi() {
        if (
            this._infoModal.html === this._infoModal.container.querySelector('.ql-editor').innerHTML
            && this._infoModal.oldSize === this._infoModal.size
            && this._infoModal.title === this._infoModal.titleField.value
            && this._infoModal.icon === this._infoModal.iconSelect.dataset['value']
        ) return Promise.resolve();

        this._enableVideoInfoModal(this._infoModal.container);
        let infoModalID = this._infoModal.id;
        // if(this._infoModal.targetNode.querySelector('.icon-custom-span')) return ;
        if(this._infoModal.targetNode.classList.contains(`user-icon`)) this.removeUserIcon();
        this._showInfoModalLoader(true);
        this._waitForSaving = true;
        const html = this._infoModal.container.querySelector('.ql-editor').innerHTML;
        const lang = this._infoModal.langField.querySelector('.select-lang-active').dataset.value;
        this._infoModal.html = this.mergePoi(lang, html);
        this._infoModal.original = this._infoModal.html;
        this._infoModal.title = this._infoModal.container.querySelector('.e3-viewer-poi-title-field').value;
        // this._infoModal.icon = validURL(this._infoModal.icon) ? this._infoModal.icon : this._infoModal.iconSelect.dataset['value'];
        this._infoModal.icon = this._infoModal.iconSelect.dataset['value'];

       return new Promise((resolve, reject) => {
            this._fireEvent('poi.save', this._preparePoiToSend(), (res) => resolve(res));
       }).then((res) => {
           this._infoModal.oldSize = this._infoModal.size;
           this._savePoiCallback(res, infoModalID);
           this._poiAsyncAction = null;
           this._setPoiTitle(this._infoModal.title);

           return Promise.resolve();
       });
    }

    mergePoi(lang, html) {
        if(this.isJSON(this._infoModal.original)) {
            const json = JSON.parse(this._infoModal.original);
            json[lang] = html;
            Object.keys(json).forEach(key => {
                if (!this._onE3TourCheckContent(json[key])) delete json[key];
            });
            html = JSON.stringify(json);
        } else {
            if (!this._onE3TourCheckContent(html)) return this._infoModal.original || JSON.stringify({});
            html = JSON.stringify({[lang]: html});
        }

        return html;
    }

    removeUserIcon() {
        this._infoModal.targetNode.classList.remove(`user-icon`);
        this._infoModal.targetNode.style.width = 'auto';
        this._infoModal.targetNode.style.height = 'auto';
        this.viewer._renderHotSpots();
    }

    setScenes(scenes, autorotate) {
        let scenesObj = super.setScenes(scenes, autorotate);
        scenes.forEach(scene => {
            if (scene.floorplan) {
                scenesObj[scene.id].floorplan = scene.floorplan;
            }
        });
        return scenesObj;
    }

    // "Detect room" in floor-edit mode: run a room-layout model on this panorama
    // and draw its room as finished, or draw by hand (lib/floorplan-detect).
    // While the panel is open clicks add no corners; "Draw by hand" is the
    // panel's own "add" control (clear + click to draw), so manual drawing is
    // the unchanged old flow.
    _setFloorpointDrawing(enable) {
        if (!this._floorplanPanel) return;
        if (enable || this._floorplanPanel.getControlValue('add')) {
            this._floorplanPanel.switchControl('add', enable);
        }
    }

    _toggleDetectRoomButton(show) {
        if (!show) {
            if (this._detectRoomPanel) this._detectRoomPanel.close();
            this._detectRoomPanel = null;
            if (this._detectRoomBtn) this._detectRoomBtn.remove();
            this._detectRoomBtn = null;
            return;
        }
        if (this._detectRoomBtn) return;
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'e3-detect-room-btn';
        btn.textContent = 'Detect room';
        btn.addEventListener('click', () => {
            if (this._detectRoomPanel) this._detectRoomPanel.close();
            this._setFloorpointDrawing(false);
            this._detectRoomPanel = new DetectRoomPanel({
                container: this.pannellumContainer,
                panorama: this.viewer.getScenePanorama(),
                onApply: (layout) => {
                    this._setFloorpointDrawing(false);
                    this.viewer.applyLayout(layout);
                },
                onDrawManually: () => {
                    this._detectRoomPanel = null;
                    this._setFloorpointDrawing(true);
                },
                // closed without a room → back to the manual drawing it was in before
                onClose: () => {
                    this._detectRoomPanel = null;
                    if (this._floorplanEditMode && !this.viewer.getVertexCount()) this._setFloorpointDrawing(true);
                },
                // what was shown and picked — kept for training once saving is built
                onDecision: (record) => this._fireEvent('floorplan.detect.decision', { scene: this.viewer.getScene(), ...record }),
            });
            this._detectRoomPanel.open();
        });
        this.pannellumContainer.appendChild(btn);
        this._detectRoomBtn = btn;
    }

    setLimitForFloors(floors) {
        this.e3plan_max_floors = floors;
    }

    toggleFloorEditMode(enable) {
        this._fireEvent('toogle-floor-mode' , enable);

        if (typeof enable === 'boolean') {
            this._floorplanEditMode = enable;
        }
        else {
            this._floorplanEditMode = !this._floorplanEditMode;
        }
        this.viewer.toggleFloorEditorMode(this._floorplanEditMode);
        this._toggleDetectRoomButton(this._floorplanEditMode);
        if(this._floorplanEditMode){
            if(!this._floorplanPanel) {
                const {e3plan_json} = this.config;
                const preview = e3plan_json ? e3plan_json.preview : null;
                let metrical = null;
                if(preview) metrical = preview.metrical;

                const promise = typeof metrical === "boolean"?  Promise.resolve(metrical) : isMetrical()

                promise.then((metrical) => {
                        this.metrical = metrical;
                        this._initFloorplanPanel(this.metrical);
                        this.viewer.updatePointFromAutoPlan();
                        this._floorplanPanel.show(this.viewer.isNeedUpdateScene());
                        this._runToggleFloorPlan();
                        this.addListenerEvents();
                    })
            }else{
                let panelFloor = this._floorplanPanel.getFloor();

                this._floorplanPanel.show(this.viewer.isNeedUpdateScene());
                this._runToggleFloorPlan();
                if (this._prevFloorplan && this.viewer.getVertexCount() === 0)  this._setPrevFloorplan();
            }
        }
        else {
            if(this._floorplanPanel) {
                this._floorplanPanel.hide();
            }
            this._runToggleFloorPlan();
        }
    }

    addListenerEvents(){
        this.on('toogle-blur-floor-mode', (enable) => {
            if(enable) this.toggleFloorEditMode(false);
        })
    }

    _setPrevFloorplan(){
        let {floors} = this._prevFloorplan;
        this._floorplanPanel.setFloor(floors);
        this._floorplanPanel.setDetails({floors});
    }

    _runToggleFloorPlan(){
        if(this._floorplanEditMode && this.viewer.getVertexCount() === 0) {
            this._onToggleFloorPlan(this._floorplanEditMode);
            this._floorplanPanel.showTipsStep(1);
        }
    }

    showPOIByID(poiID, order, lang) {
        let infoDiv = this.container.querySelector(`.info-${poiID}`);

        if (!infoDiv) return;

        this._showInfo(poiID, '', '', '', infoDiv, '', '', order, lang);
    }

    _onE3TourInfo({resolve, reject}) {
        if (!this.config.infoID) return resolve('<p></p>');

        this._helperService.ajaxCall(this.config.infoURL)
            .then((body) => resolve(body))
            .catch((error) => reject(error))
    }

    _onE3TourInfoSave({html, resolve, reject}) {
        let empty = !this._onE3TourCheckContent(html);
        let promise;

        if (empty && this.config.infoID) {
            this._onE3TourInfoDelete({resolve, reject});
        } else if (empty) {
            resolve('<p><br></p>');
        } else {
            promise = new Promise((_resolve, _reject) => this._fireEvent('tour-info.save', {html, resolve: _resolve, reject: _reject}))

            if (this.config.infoID) {
                promise
                    .then((res) => {
                        let id = this.config.infoID;

                        this.config.infoURL = this.config.infoURL.replace(id, res.data.id);
                        this.config.infoID = res.data.id;

                        resolve(res)
                    })
                    .catch((error) => reject(error))
            } else {
                promise
                    .then((res) => {
                        this.config.infoURL += res.data.id;
                        this.config.infoID = res.data.id;

                        resolve(res)
                    })
                    .catch((error) => reject(error))
            }
        }
    }

    _onE3OpenContent() {
        if(!this._floorplanPanel) return ;

        this._floorplanPanel.minimize(this.viewer.getFloorplanWithPreview());
    }

    _onE3TourInfoDelete({resolve, reject}) {
        let promise = new Promise((_resolve, _reject) => this._fireEvent('tour-info.delete', {resolve: _resolve, reject: _reject}));

        promise
            .then(() => {
                this.config.infoURL = this.config.infoURL.replace(this.config.infoID, '');
                this.config.infoID = null;

                resolve();
            })
            .catch((error) => reject(error))
    }

    _onE3TourCheckContent(html) {
        return !!html.replace(/ /g, '').replace(/<br\s*\/?>/g, '').replace(/<p><\/p>/g,'').length
    }

    _checkE3PlanConfigIntegrity(config, scenes) {
        if (!config) return null;

        let layers, previewLayers, iterateArray, mapping,
            e3planConfig = Object.assign({}, config);

        try {
            ({layers, preview:{layers: previewLayers}} = config);
            iterateArray = [layers, previewLayers];
            mapping = [e3planConfig.layers, e3planConfig.preview.layers];
        } catch(e) {
            ({layers} = config);
            previewLayers = null;
            iterateArray = [layers];
            mapping = [e3planConfig.layers];

            console.info('< preview > property is missing in e3plan_json config');
        }

        iterateArray.forEach((_layers, index) => {
            Object.keys(_layers).forEach((layerID) => {
                Object.keys(_layers[layerID].areas).forEach((areaID) => {
                    const {properties:{scene:{id: sceneID}}} = _layers[layerID].areas[areaID];

                    if (scenes.some((scene) => scene.id === sceneID)) return;

                    mapping[index][layerID] = FloorplanManager.removeSceneFromLayer(_layers[layerID], areaID);
                });
            })
        });

        return e3planConfig;
    }

    e3TourInfoSave() {
        return this._panel.saveTourInfo();
    }

    generate3DTextures() {
        if (!this._e3plan3D) this._initE3Plan3D();

        this.disableE3Plan3DInterrupting();

        return this._e3plan3D.init(true, true);
    }

    disableE3Plan3DInterrupting() {
        this._disableE3Plan3DInterrupting = true;
    }

    enableE3Plan3DInterrupting() {
        this._disableE3Plan3DInterrupting = false;
    }

    is3DPlanHidden() {
        return this._e3plan3D && this._e3plan3D.isHidden();
    }

    is3DPlanExist() {
        return this._e3plan3D;
    }

    autoSaving(res) {
        if(res){
            this._floorplanPanel.hideAutoSaving();
        }else{
            this._floorplanPanel.errorAutoSaving();
        }
    }

    triggerOn3DPlanClick() {
        this._on3DPlanClick(null);
    }


}

Object.assign(AdminViewer.prototype, BlurControlller);
Object.assign(AdminViewer.prototype, RenderZoneController);

export default AdminViewer;
